import axios from "axios";
export const ZATCA_URL = "api/zatca";

export const OnboardPosToZatca = (posId, otp, type,timezone) => {
  let data = {
    posId: posId,
    // useTestCSR: type !== "Simulation" ? true : false,
    environment: type?.toLowerCase(),
    timezone: timezone
  };
  return axios.post(`${ZATCA_URL}/onboarding`, data, {
    headers: {
      otp: otp,
      "Accept-Version": "V2",
    },
  });
};

export const getZatcaOnboardingLogs = (companyId, searchData) => {
  return axios.get(
    `/api/zatca/onboarding-logs/${companyId}?${searchData?.limit ? `limit=${searchData?.limit}` : "limit=10"}${
      searchData?.searchName ? `&searchName=${searchData?.searchName}` : ""
    }${searchData?.startDate ? `&startDate=${searchData?.startDate}` : ""}${searchData?.endDate ? `&endDate=${searchData?.endDate}` : ""}${
      searchData?.actionId ? `&actionId=${searchData?.actionId}` : ""
    }`,
  );
};

export const expireCertificateInTwoMinutes = (posId) => {
  let data = {
    posId: posId,
  };
  return axios.patch(`/api/zatca/expireCertificateInTwoMinutes`, data);
};

export const reportInvoiceToZatca = (invoiceId, setToPending) => {
  const payload = {
    invoiceId: invoiceId,
    shouldPendingToReport: setToPending,
  };
  return axios.post(`/api/zatca/invoices/reporting`, payload);
};

export const createInvoiceXmlDownloadLogs = (companyId, invoiceId, logMessage, fileName) => {
  let data = {
    logMessage: logMessage,
    fileName: fileName,
  };
  return axios.post(`/api/invoice/createDownloadXmlLog/${companyId}/${invoiceId}`, data);
};

export const revokePosCertificate = (posId, forceRevokeFailure,timezone) => {
  let data = {
    posId: posId,
    forceRevokeFailure: forceRevokeFailure,
    timeZone: timezone
  };
  return axios.patch(`/api/zatca/revokePosCertificate`, data);
};
